export const adminSubRoute = {
  copyTemplate: "copy-template",
  duplicateCampaign: "duplicate-campaign",
} as const;

export interface AdminRoutes {
  sub: (typeof adminSubRoute)[keyof typeof adminSubRoute];
  method?: "Post";
}
